import type { SVGProps } from 'react';

export type FlagPTProps = SVGProps<SVGSVGElement> & {
  size?: number;
};

export const FlagPT = ({ size = 60, ...rest }: FlagPTProps) => (
  <svg
    width={size}
    height={size * (40 / 60)}
    viewBox="0 0 60 40"
    role="img"
    aria-label="Português"
    {...rest}
  >
    <title>Portugu&ecirc;s</title>
    <rect x="1" y="1" width="23.2" height="38" fill="#1F7A3A" />
    <rect x="24.2" y="1" width="34.8" height="38" fill="#C8362C" />
    {/* Armillary disc on the seam — simplified to a plain ring + inner circle. */}
    <circle cx="24.2" cy="20" r="6" fill="#E8B43C" stroke="var(--color-ink)" strokeWidth="0.9" />
    <circle cx="24.2" cy="20" r="3" fill="#F4ECDC" stroke="var(--color-ink)" strokeWidth="0.7" />
    <rect
      x="1"
      y="1"
      width="58"
      height="38"
      fill="none"
      stroke="var(--color-ink)"
      strokeWidth="1.5"
    />
  </svg>
);
